import * as dayjs from 'dayjs';
import { ICompra } from './compra.model';
import { ICredito } from './credito.model';
import { IEndereco } from './endereco.model';
import { INotaFiscal } from './nota-fiscal.model';
import { IPagamentoResgate } from './pagamento-resgate.model';
import { IResgate } from './resgate.model';
import { ITelefone } from './telefone.model';
import { Account } from './account.model';
import { Cooperativa } from './cooperativa.model';

export interface IDadosUsuario {
  id?: number;
  razaoSocial?: string | null;
  nome?: string | null;
  documento?: string | null;
  dataNascimento?: dayjs.Dayjs | null;
  observacoes?: string | null;
  balance?: number | 0;
  telefones?: ITelefone[] | null;
  enderecos?: IEndereco[] | null;
  notaFiscals?: INotaFiscal[] | null;
  creditos?: ICredito[] | null;
  compras?: ICompra[] | null;
  resgates?: IResgate[] | null;
  pagamentoResgates?: IPagamentoResgate[] | null;
  user?: Account | null;
  balanceValor?:number|0;
  vendaAntecipada?:boolean | true;
  qtdeVendaAntecipada?:number | null;
  valorVenda?: number | null;
  cooperativa?: Cooperativa[] | null;
  valorCompra?: number | 0;
}

export class DadosUsuario implements IDadosUsuario {
  constructor(
    public id?: number,
    public razaoSocial?: string | null,
    public nome?: string | null,
    public documento?: string | null,
    public dataNascimento?: dayjs.Dayjs | null,
    public observacoes?: string | null,
    public balance?: number | 0,
    public telefones?: ITelefone[] | null,
    public enderecos?: IEndereco[] | null,
    public notaFiscals?: INotaFiscal[] | null,
    public creditos?: ICredito[] | null,
    public compras?: ICompra[] | null,
    public resgates?: IResgate[] | null,
    public pagamentoResgates?: IPagamentoResgate[] | null,
    public user?: Account | null,
    public balanceValor?:number|0,
    public vendaAntecipada?:boolean|true,
    public qtdeVendaAntecipada?:number|null,
    public valorVenda?: number | null,
    public cooperativa?: Cooperativa[] | null,
    public valorCompra?: number | null
  ) {}
}

export function getDadosUsuarioIdentifier(dadosUsuario: IDadosUsuario): number | undefined {
  return dadosUsuario.id;
}
